import { BaseComponent } from "../../../components/BaseComponent";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileSignature, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import styled from "styled-components";
import { Modal, ModalControls } from "../../../components/Modal";
import { Button } from "../../../components/Buttons";
import { deleteWorkflowProduct } from "../actions";

const ActionsContainer = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

const IconWrapper = styled.div`
  color: ${props => (props?.color === 'green' ? '#11ab79' : props?.color === 'orange' ? '#FC9629' : '#d50046')};
`;

export class WorkflowProductActionsContainerComp extends BaseComponent {

  onClickDeleteBtn(e) {
    this.setState({ removeProductConfirmation: true });
  }

  renderConfirmationModal() {
    if (!this.state.removeProductConfirmation) return '';

    return (
      <Modal onClose={this.setStateFn({ removeProductConfirmation: false })} title={this.lbl(`workflows.productDetails.removeConfirmationTitle`)}>
        <ModalControls>
          <Button
            onClick={() => {
              this.props.deleteWorkflowProduct();
              this.setState({ removeProductConfirmation: false });
            }}
            primary
          >
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.setStateFn({ removeProductConfirmation: false })}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }
  render() {
    return (
      <>
        <ActionsContainer>
          <IconWrapper color={'green'}>
            <div
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faFileSignature} />
            </div>
          </IconWrapper>
          <IconWrapper color={'red'}>
            <div
              onClick={evt => {
                evt.stopPropagation();
                this.onClickDeleteBtn(evt);
              }}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </div>
          </IconWrapper>
        </ActionsContainer>
        {this.renderConfirmationModal()}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    deleteWorkflowProduct() {
      dispatch(deleteWorkflowProduct(ownProps.workflow.id, ownProps.workflowProduct.id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export const WorkflowProductActionsContainer = compose(withConnect, withRouter)(WorkflowProductActionsContainerComp);
